import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import CadastroContainer from "../../../../components/CadastroContainer/CadastroContainer";
import FormRoles from "../FormRoles/FormRoles";
import "./CadastroRoles.css";
import RoleService from "../../../../services/RolesService";

const CadastroRoles = () => {
	const { roleId } = useParams();
	const { state } = useLocation();
	const [role, setRole] = useState()
	const [type, setType] = useState("");

	async function loadRole(id) {
		const response = await RoleService.getRole(id);
		if (response.data) {
			setRole(response.data);
		}
	}

	useEffect(() => {
		setType(roleId || state ? "edicao" : "cadastro");

		if (role) {
			setRole(state);
			return;
		}

		if (roleId) {
			loadRole(roleId);
		}
	}, [state, roleId]);

	return (
		<CadastroContainer>
			<FormRoles role={role} type={type} />
		</CadastroContainer>
	);
};

export default CadastroRoles;
